import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TFunction } from 'i18next';

interface IReportLinkCellProps {
    hasReport?: boolean;
    canPreviewReport?: boolean;
    onOpen: () => void;
    t: TFunction;
}

/**
 * Report-link column cell. Shows a clickable paperclip when a report is
 * available (a stored report, or a WIP job that can render a live preview),
 * and renders nothing for not-started jobs. Clicking opens an in-browser
 * preview via the parent's onOpen handler.
 */
export const ReportLinkCell: React.FC<IReportLinkCellProps> = ({
    hasReport,
    canPreviewReport,
    onOpen,
    t
}) => {
    if (!hasReport && !canPreviewReport) {
        return null;
    }

    const handleClick = (e: React.MouseEvent) => {
        // Prevent the row/cell click handlers (edit modal, expander) from firing.
        e.stopPropagation();
        onOpen();
    };

    return (
        <span
            className="report-link-icon"
            role="button"
            title={String(t('report'))}
            style={{ cursor: 'pointer' }}
            onClick={handleClick}
        >
            <FontAwesomeIcon icon={['far', 'paperclip']} />
        </span>
    );
};
